module.exports = __webpack_public_path__ + "static/media/brand-refresh-storefront.40689540.svg";